import { RTKUtils, DiningVenuesInfoService } from '@sevenrooms/api'
import { baseReservationWidgetApi } from './BaseReservationWidgetApi'

const DiningVenuesInfoApiTags = ['DiningVenuesInfo']

export const diningVenuesInfoApi = baseReservationWidgetApi.enhanceEndpoints({ addTagTypes: DiningVenuesInfoApiTags }).injectEndpoints({
  endpoints: builder => ({
    getDiningVenuesInfo: builder.query({
      queryFn: RTKUtils.rtkQuery(DiningVenuesInfoService.getDiningVenuesInfo),
    }),
  }),
})

export const { useGetDiningVenuesInfoQuery } = diningVenuesInfoApi
